export const checkboxFormItemLayout = {
  labelCol: {
    sm: { span: 16 },
  },
  wrapperCol: {
    sm: { span: 8 },
  },
};

export const threeColumnFormItemLayout = {
  labelCol: {
    sm: { span: 12 },
  },
  wrapperCol: {
    sm: { span: 12 },
  },
};
export const smallFormItemLayout = {
  labelCol: {
    sm: { span: 8 },
  },
  wrapperCol: {
    sm: { span: 16 },
  },
};

export const smallTailFormItemLayout = {
  wrapperCol: {
    sm: { span: 16, offset: 8 },
  },
};

export const formItemLayout = {
  labelCol: {
    sm: { span: 4 },
  },
  wrapperCol: {
    sm: { span: 20 },
  },
};

export const formItemButtonLayout = {
  labelCol: {
    sm: { span: 4 },
  },
  wrapperCol: {
    sm: { span: 16 },
  },
};

export const verticalItemLayout = {
  labelCol: {
    sm: { span: 4 },
  },
  wrapperCol: {
    sm: { span: 24 },
  },
};

export const tailFormItemLayout = {
  wrapperCol: {
    sm: { span: 20, offset: 4 },
  },
};
